import 'fullcalendar'
import * as moment from 'moment'
import { Component, OnInit, ViewEncapsulation, OnDestroy, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { DialogService } from '../../services/modal-dialogs';
import { AddEventDialog } from '../../dialogs/add.event/add.event.dialog';
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '../../services/ss-api.service';
import { TrainingCalendarRequest } from '../../models/ss-api/requests/training.calendar.request';
import { ScheduleModule, Schedule } from 'primeng/primeng';
import { TrainingEvent } from '../../models/domain/training.event';
import { TrainingClass } from '../../models/domain/training.class';
import { EditEventDialog } from '../../dialogs/edit.event/edit.event.dialog';
import { RescheduleTrainingEventRequest } from '../../models/ss-api/requests/reschedule.training.event.request';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { SweetAlertService } from 'ng2-cli-sweetalert2';

interface CalendarEvent {
    title: String;
    start: Date;
    end: Date;
    event: TrainingEvent;
}

class FilterOption {
    label: string;
    value: {
        id: number;
        type: string;
    }
}

@Component({
    selector: 'training-calendar',
    templateUrl: './training.calendar.component.html',
    styleUrls: ['training.calendar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class TrainingCalendarComponent implements OnInit, OnDestroy {
    @ViewChild('Calendar') Calendar: Schedule;
    IsBusy: boolean = false;
    originalEvents: CalendarEvent[];
    events: CalendarEvent[];
    paramEventID: number;
    headerConfig: Object;
    filterOptions: Array<FilterOption> = new Array<FilterOption>();
    selectedFilters: Array<FilterOption> = new Array<FilterOption>();
    c: TrainingClass;
    minTime: String = '07:00:00';
    maxTime: String = '20:00:00';
    currentVersion: string;
    minimumVersionv2: string;
    minimumVersionv3: string;
    rescheduleSubscription: Subscription;
    activeEvent: TrainingEvent;
    CalendarStartDate: Date;
    CalendarEndDate: Date;

    constructor(private dialogService: DialogService, private api: ssApiService, private gb: GlobalService, private schedule: ScheduleModule, private route: ActivatedRoute, private location: Location, private sweetAlert: SweetAlertService) {
        this.filterOptions = [
            {
                label: 'Pool Studio', value: { id: 2, type: 'product' }
            },
            {
                label: 'VizTerra', value: { id: 1, type: 'product' }
            },
            {
                label: 'VIP 3D', value: { id: 3, type: 'product' }
            },
            {
                label: 'Joan Fowler', value: { id: 13, type: 'trainer' }
            },
            {
                label: 'Maryrose Bersamin', value: { id: 14, type: 'trainer' }
            }
        ]
    }

    ngOnInit() {
        this.gb.SetPageTitle('Training Calendar');
        this.IsBusy = true;
        this.headerConfig = {
            'left': 'prev,next today',
            'center': 'title',
            'right': 'month,agendaWeek,listMonth'
        }
        this.route.paramMap.subscribe(params => {
            this.paramEventID = parseInt(params.get('event'));
        })
    }

    ngOnDestroy() {

    }

    loadCalendar(event) {
        this.CalendarStartDate = event.view.start;
        this.CalendarEndDate = event.view.end;
        this.renderCalendar(event.view.start, event.view.end);
    }

    renderCalendar(start: Date, end: Date) {
        this.loadEvents(this.events, start, end).then(response => {
            this.events = response;
            this.originalEvents = response;
            this.IsBusy = false;

            if (this.paramEventID) {
                let e = this.GetEventByID(this.route.params['_value'].event)
                if (e) {
                    let disposable = this.dialogService.addDialog(EditEventDialog, {
                        title: 'Edit Event',
                        event: e,
                        currentVersion: this.currentVersion,
                        minimumVersionv2: this.minimumVersionv2,
                        minimumVersionv3: this.minimumVersionv3,
                    }, { width: 1000, height: 800 }).subscribe(result => {
                        this.activeEvent = new TrainingEvent();
                        disposable.unsubscribe();
                        this.paramEventID = null;
                        this.location.replaceState('/training/calendar');
                    });
                    this.activeEvent = e;
                } else {
                    this.sweetAlert.swal({
                        title: 'Not Found',
                        text: 'This event could not be found and was most likely deleted.',
                        type: 'warning',
                        showCancelButton: true
                    }).then(response => {
                        this.activeEvent = new TrainingEvent();
                        this.paramEventID = null;
                        this.location.replaceState('/training/calendar');
                        return response;
                    }, (dismiss) => {
                        return false;
                    })
                }
            }
        });
    }

    async loadEvents(events, start: Date, end: Date): Promise<CalendarEvent[]> {
        let request: TrainingCalendarRequest = {
            StartDate: start,
            EndDate: end
        };
        this.IsBusy = true;
        let eventTemplate: CalendarEvent;
        let tempEvents = [];

        let response = this.api.GetAdminTrainingCalendar(request).toPromise().then(r => {
            r.Data['TrainingEvents'].forEach(function (e) {
                let trainingClass = r.Data['TrainingClasses'].filter(c => c.ID == e.TrainingClassID)[0];
                let duration = moment(trainingClass.ClassDuration, 'hh:mm:ss');
                eventTemplate = {
                    title: trainingClass.ClassTitle,
                    start: new Date(e.EventDateTime),
                    end: moment(e.EventDateTime).add({ hours: duration.hours(), minutes: duration.minutes() }).toDate(),
                    event: e
                }
                eventTemplate.event.TrainingClass = trainingClass;
                tempEvents.push(eventTemplate);
            })
            this.currentVersion = r.Data.CurrentSoftwareVersion;
            this.minimumVersionv2 = r.Data.TrainingMinimumSoftwareVersionv2;
            this.minimumVersionv3 = r.Data.TrainingMinimumSoftwareVersionv3;
            this.IsBusy = false;
            events = tempEvents;
            return events;
        }).catch(error => {

        });

        return response;
    }

    GetEventByID(id): TrainingEvent {
        for (let event of this.events) {
            if (event.event.ID == id) {
                return event.event;
            }
        }
    }

    onEventRender(event, element, view) {
        let productHTML = '';
        let productBorder = '';
        let trainerLabel = '(' + event.event.TrainerName.split(' ')[0].slice(0, 1) + event.event.TrainerName.split(' ')[1].slice(0, 1) + ')';

        // For Maryrose
        if (trainerLabel == '(MB)') trainerLabel = '(MR)';

        event.event.TrainingClass.ProductIDs.forEach(function (product) {
            let icon = '';
            let color = '#000';
            switch (product) {
                case 3:
                    icon = '../../assets/images/icons/logo-icons-vip3d-xs.png';
                    color = '#0064DF';
                    break;
                case 2:
                    icon = '../../assets/images/icons/logo-icons-pool-studio-xs.png';
                    color = '#FF0000';
                    break
                case 1:
                    icon = '../../assets/images/icons/logo-icons-vizterra-xs.png';
                    color = '#64A000';
                    break
                default:
                    return false;
            }
            productHTML += '<img class="event-software-icon" style="border-color: ' + color + '" src="' + icon + '" />'
            productBorder += '<div class="event-product-section" style="background-color: ' + color + '"></div>'
        }, this)

        element.html('');
        if (moment().isAfter(event.event.EventDateTime, 'day')) {
            element.append('<div class="fc-old"><div class="event-product-border">' + productBorder + '</div><div class="event-top"><h4 class="event-title">' + event.title + ' ' + trainerLabel + '</h4><div class="event-icons">' + productHTML + '</div></div><div class="event-bottom"><p class="event-date">' + moment(event.start).format('hh:mm a') + ' - ' + moment(event.end).format('hh:mm a') + '</p><p class="event-attendees"><i class="fa fa-user"></i> ' + event.event.CheckedInAttendeeCount + '/' + event.event.AttendeeCount + '</p></div></div>');
        } else if (moment().isSame(event.event.EventDateTime, 'day')) {
            element.append('<div class="event-product-border">' + productBorder + '</div><div class="event-top"><h4 class="event-title">' + event.title + ' ' + trainerLabel + '</h4><div class="event-icons">' + productHTML + '</div></div><div class="event-bottom"><p class="event-date">' + moment(event.start).format('hh:mm a') + ' - ' + moment(event.end).format('hh:mm a') + '</p><p class="event-attendees"><i class="fa fa-user"></i> ' + event.event.CheckedInAttendeeCount + '/' + event.event.AttendeeCount + '</p></div>');
        } else {
            element.append('<div class="event-product-border">' + productBorder + '</div><div class="event-top"><h4 class="event-title">' + event.title + ' ' + trainerLabel + '</h4><div class="event-icons">' + productHTML + '</div></div><div class="event-bottom"><p class="event-date">' + moment(event.start).format('hh:mm a') + ' - ' + moment(event.end).format('hh:mm a') + '</p><p class="event-attendees"><i class="fa fa-user"></i> ' + event.event.AttendeeCount + '</p></div>');
        }
    }

    onEventDrop(e) {
        let request: RescheduleTrainingEventRequest = {
            TrainingEventID: e.event.event.ID,
            NewEventDateTime: new Date(e.event.start.toISOString())
        }
        e.event.event.EventDateTime = e.event.start;
        this.api.RescheduleTrainingEvent(request).toPromise().then(response => {
            if (!response.Data.GoogleCalendarResult) { this.GoogleCalendarWarning() };
        }).catch(error => {

        })
    }

    onEventClick(e) {
        let disposable = this.dialogService.addDialog(EditEventDialog, {
            title: 'Edit Event',
            event: e.calEvent.event,
            currentVersion: this.currentVersion,
            minimumVersionv2: this.minimumVersionv2,
            minimumVersionv3: this.minimumVersionv3,
        }, { width: 1000, height: 800 }).subscribe(result => {
            disposable.unsubscribe();
            this.renderCalendar(this.CalendarStartDate, this.CalendarEndDate);
        });
        this.activeEvent = e.calEvent.event;
    }

    onDayClick(date) {
        let disposable = this.dialogService.addDialog(AddEventDialog, {
            title: 'Add Event',
            date: date
        }, { width: 400, height: 450 }).subscribe(result => {
            this.renderCalendar(this.CalendarStartDate, this.CalendarEndDate);
            disposable.unsubscribe();
        })
    }

    addEvent() {
        let disposable = this.dialogService.addDialog(AddEventDialog, {
            title: 'Add Event',
            date: new Date()
        }, { width: 400, height: 450 }).subscribe(result => {
            this.renderCalendar(this.CalendarStartDate, this.CalendarEndDate);
            disposable.unsubscribe();
        })
    }

    onFilterChange(event) {
        if (this.selectedFilters.length == 0) {
            this.events = this.originalEvents;
        } else {
            this.events = this.originalEvents.filter(function (e) {
                for (let filter of event.value) {
                    if (filter.type == 'product' && e.event.TrainingClass.ProductIDs.indexOf(filter.id) < 0) {
                        return false;
                    } else if (filter.type == 'trainer' && e.event.TrainerID != filter.id) {
                        return false;
                    }
                }
                return true;
            })
        }
    }

    GoogleCalendarWarning() {
        this.sweetAlert.swal({
            title: 'Google Calendar',
            text: 'Google Calendar has failed to sync due to technical difficulties. If this problem persists please contact support',
            type: 'warning'
        })
    }
}
